import Widget from 'models/dashboard/widget'

Widget.AgentSourceDistributionPieWidget = Widget.extend({
  agentIds: function () {
    return this.get('agent_ids');
  }
});

export default Widget.AgentSourceDistributionPieWidget;

